import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { AppService } from 'src/app/services/app.service';
import * as uuid from 'uuid';

@Component({
  selector: 'pagamento-dados-passageiros',  
  templateUrl: './pagamento-dados-passageiros.component.html',
  styleUrls: ['./pagamento-dados-passageiros.component.scss']
})
export class PagamentoDadosPassageirosComponent implements OnInit {

  @Input("carrinho") carrinho:any                            = {};  
  @Output("change") change                                   = new EventEmitter();  
  @Output("setSolicitarPassageiros") setSolicitarPassageiros = new EventEmitter();   
  @Input("passageiros") passageiros                          = [];
  @Input("solicitarPassageiros") solicitarPassageiros        = false;
  public show                                                = false; 
  public ids                                                 = [];          
  public passageirosCombo = {
    adt: [],
    chd: [],
    snr: [],
    inf: []
  }

  constructor(private app: AppService){

  } 
  /***
   * 
   * Click
   * 
   **/    
  _clickPassageiro(passageiro,p){

    p.nome      = passageiro.nome; 
    p.sobrenome = passageiro.sobrenome; 
    p.documento = passageiro.documento; 
    p.telefone  = passageiro.telefone; 

  }
  /***
   * 
   * Change passageiro
   * 
   */
  _changeInput(p){

    if(p.nome !== "" && p.sobrenome !== "" && p.documento !== ""){

      let status = false;
      let  i     = 0;

      for (let index = 0; index < this.passageirosCombo[p.tipo].length; index++) {

        if(p._id == this.passageirosCombo[p.tipo]._id){

          i      = index;
          status = true;

        }
        
      }
      if(status == true){
        this.passageirosCombo[p.tipo][i] = p;
      }else{
        this.passageirosCombo[p.tipo].push(p);
      }

    }

  }
  /**
   * 
   * Show
   * 
   */
  _show(){

    this.solicitarPassageiros = true; 
    this.setSolicitarPassageiros.emit(true);

  }
  /**
   * 
   * Hide
   * 
   */
  _hide(){ 

    this.solicitarPassageiros = false;
    this.setSolicitarPassageiros.emit(false);

  }
  /**
   * 
   * Passageiro selected
   * 
   */
  isSelectedPassageiro(id){

    let status = false;

    for (let index = 0; index < this.ids.length; index++) {
      
      if(id == this.ids[index]){
        status = true;
        break;
      }
      
    }

    return status;
    
  }
  /**
   * 
   * Get passageiro
   * 
   */ 
  getPassageiro(passageiros,tipo){

    let data = null;

    for(let index = 0;index < passageiros.length;index++) {
      
      if(passageiros[index].tipo == tipo){

        if(!this.isSelectedPassageiro(passageiros[index].id)){ 

          data = passageiros[index];
          break;

        }

      }
      
    }

    return data;

  }
  /**
   * 
   * Set campos passageiros
   * 
   */
  setCamposPassageiros(){

    let adt                  = 0;
    let snr                  = 0;
    let inf                  = 0;
    let chd                  = 0;
    let passageiros          = [];
    let passageiros_carrinho = [];
    let passageiro           = null;

    for(let index = 0;index < this.carrinho.cart_itens.length;index++) {
      
      this.ids              = [];
      passageiros           = [];
      passageiro            = null;
      passageiros_carrinho  = this.carrinho.cart_itens[index].paxs;
      adt                   = this.carrinho.cart_itens[index].qtd_adt;
      snr                   = this.carrinho.cart_itens[index].qtd_snr;
      inf                   = this.carrinho.cart_itens[index].qtd_inf;
      chd                   = this.carrinho.cart_itens[index].qtd_chd; 

      for(let index = 0;index < adt;index++) {
        
        passageiro = this.getPassageiro(passageiros_carrinho,"adt");

        if(passageiro == null){
          
          passageiro = {
            _id: uuid.v4(),
            nome: "",
            sobrenome: "",
            telefone: "",
            documento: "",
            tipo: "adt",
            titular: false
          };

          passageiros.push(passageiro); 

        }else{
          passageiros.push(passageiro);
          this.ids.push(passageiro.id); 
        }
      }
      for(let index = 0;index < snr;index++) {

        passageiro = this.getPassageiro(passageiros_carrinho,"snr");
        
        if(passageiro == null){
          
          passageiros.push({
            nome: "",
            sobrenome: "",
            telefone: "",
            documento: "",
            tipo: "snr",
            titular: false
          });

        }else{
          passageiros.push(passageiro);
          this.ids.push(passageiro.id); 
        }  
        
      }
      for(let index = 0;index < chd;index++) {

        passageiro = this.getPassageiro(passageiros_carrinho,"chd");

        if(passageiro == null){
          
          passageiros.push({
            nome: "",
            sobrenome: "",
            telefone: "",
            documento: "",
            tipo: "chd",
            titular: false
          });
        
        }else{
          passageiros.push(passageiro);
          this.ids.push(passageiro.id); 
        }  
          
      }
      for(let index = 0;index < inf;index++) {

        passageiro = this.getPassageiro(passageiros_carrinho,"inf");

        if(passageiro == null){

          passageiros.push({
            nome: "",
            sobrenome: "",
            telefone: "",
            documento: "",
            tipo: "inf",
            titular: false 
          });

        }else{
          passageiros.push(passageiro);
          this.ids.push(passageiro.id); 
        }  
        
      }

      
      this.carrinho.cart_itens[index].passageiros = passageiros;  
      this.passageiros.push({
        item: {
          nome: this.carrinho.cart_itens[index].nome,
          id: this.carrinho.cart_itens[index].id 
        },
        passageiros: passageiros   
      });

      this.setPassageiroTitular();

    }

  }
  /**
   * 
   * Seta o passageiro titular
   * 
   */
  setPassageiroTitular(){

    let ok = false;

    for (let index = 0; index < this.passageiros.length; index++) {
      
      if(!ok){

        for (let i = 0;i < this.passageiros[index].passageiros.length;i++) {
          
          if(this.passageiros[index].passageiros[i].tipo == "adt" || this.passageiros[index].passageiros[i].tipo == "snr"){
            this.passageiros[index].passageiros[i].titular = true;
            ok = true; 
          }
          if(ok){
            break; 
          }
          
        }     

      }else{
        break;
      }

      
    }


  }
  /**
   * 
   * Set titular
   * 
   */
  setTitular(passageiro){

    for(let index = 0; index < this.passageiros.length; index++) {
      for(let i = 0;i < this.passageiros[index].passageiros.length;i++) {
        this.passageiros[index].passageiros[i].titular = false;
      }
    }

    passageiro.titular = true;    

  }
  /**
  * 
  * Inicializa as Funções 
  * 
  * 
  **/
  ngOnInit():void{
    
    this.setCamposPassageiros();
    
    if(this.carrinho.paxs.length > 0){
      this.show = true; 
    }

  } 

}
